/**
 * Helper function to create consistent event data structure
 */
export const createEventData = (page, additionalData = {}) => {
  return {
    page,
    timestamp: new Date().toISOString(),
    url: window.location.pathname,
    ...additionalData,
  };
};

/**
 * Example usage in components:
 *
 * import { useAnalytics } from "@core/analytics";
 * import { ANALYTICS_EVENTS, createEventData } from "@core/analytics/events";
 *
 * const MyComponent = () => {
 *   const { trackEvent } = useAnalytics();
 *
 *   const handleClick = () => {
 *     trackEvent(
 *       ANALYTICS_EVENTS.BUTTON_CLICKED,
 *       createEventData("Dashboard", { buttonName: "Export" })
 *     );
 *   };
 * };
 */
